// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .skeleton-moment[data-v-2ced7a48]{padding:10px!important}", ""]);
// Exports
module.exports = exports;
